/* DARIA — صورة الفاريانت + إصلاح عرض رمز الدرهم */
(function () {

  /* ---------- رمز الدرهم: السعر يُكتب بـ textContent فيظهر الكود كنص،
     نحوّله إلى HTML حقيقي فور تغيّره ---------- */
  function fixMoney(el) {
    if (!el) return;
    var t = el.textContent;
    if (t && t.indexOf('<') > -1 && t.indexOf('>') > -1) {
      el.innerHTML = t;
    }
  }
  function watchMoney() {
    document.querySelectorAll('[data-price], [data-compare]').forEach(function (el) {
      if (el.dataset.moneyWatch) return;
      el.dataset.moneyWatch = '1';
      fixMoney(el);
      new MutationObserver(function () { fixMoney(el); })
        .observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- صورة الفاريانت ---------- */
  function initImage() {
    var root = document.querySelector('[data-daria-product]');
    var img  = document.getElementById('dGalleryMain');
    var json = document.querySelector('[data-daria-variants]');
    if (!root || !img || !json || root.dataset.imgFix) return;
    root.dataset.imgFix = '1';

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');

    function bigger(url) {
      if (!url) return url;
      return url.indexOf('?') > -1 ? url + '&width=1400' : url + '?width=1400';
    }

    function swap() {
      var chosen = Array.prototype.map.call(
        root.querySelectorAll('.d-opt__vals input:checked'),
        function (i) { return i.value; }
      );
      if (!chosen.length) return;
      var v = variants.find(function (x) {
        return chosen.every(function (val, i) { return x.options[i] === val; });
      });
      if (!v || !v.featured_image || !v.featured_image.src) return;

      var next = bigger(v.featured_image.src);
      if (img.src === next) return;

      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.style.opacity = '.35';
      var pre = new Image();
      pre.onload = function () {
        img.src = next;
        img.style.opacity = '';
        var box = img.closest('.d-gallery__main');
        if (box) { delete box.dataset.filled; }
        document.dispatchEvent(new Event('shopify:section:load'));
      };
      pre.onerror = function () { img.src = next; img.style.opacity = ''; };
      pre.src = next;

      document.querySelectorAll('[data-thumb]').forEach(function (b) {
        var same = b.dataset.thumb && b.dataset.thumb.split('?')[0] === v.featured_image.src.split('?')[0];
        b.setAttribute('aria-current', same ? 'true' : 'false');
      });
    }

    root.querySelectorAll('.d-opt__vals input').forEach(function (i) {
      i.addEventListener('change', function () { setTimeout(swap, 10); });
    });
    img.style.transition = 'opacity .2s ease';
    swap();
  }

  function init() { watchMoney(); initImage(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
